import axios from "axios"

export const getUrlFileSize = (url, setState=()=> {}) => {
  axios?.get(url, { responseType: 'blob' })?.then(res => {
    setState(res?.data?.size)
  })
}